import moment from 'moment';
import HttpFactory from '@/mixins/http.factory';
import TagsInput from '@/components/Inputs/TagsInput'
import { Select, Option } from 'element-ui'
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import { mapState, mapActions,mapGetters } from 'vuex'
export default {
	name:'create-work-item',
	mixins:[HttpFactory],
	data () {
		return {
			htmlMessage:null,
			data:null,
			ticket_fields:[],
			fieldMapping:[],
			devOpsProjects:[],
            devOpsProjectData:{
                workItemTypes:[],
                nodesList:[],
                fieldsList:[],
                usersList:[],
                customFields:[],
            },
			showTags:false,
            editor_reproSteps_Obj:null,
            editor_description_Obj:null,
            createItemData:{attachments:[],files:[],fields:{},relations:{}},
			severityValues: ["1 - Critical","2 - High","3 - Medium","4 - Low"],
			priorityValues: [1, 2, 3, 4],
			isResolutionField: false,
			isAcptCriteriaField: false,
			isSystemInfoField:false,
		}
	},
	computed:{
		//...mapState('zendesk',['zdTicket_fields'])//no need yet
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			//var count=0;
			modalClient.on('send_data_to_modal', (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					_self.workItemFields();
				}
				// _self.zendeskInfo = data;
				// if(_self.$route.params.zdTicketId)_self.zendeskInfo.ticket.id = _self.$route.params.zdTicketId;
				// count++;
				// if(count==1){
				// 	_self.workItemFields();
				// }
			});
		},
		initDropzone(data){
			const _self=this;
			if(!data || !data.userInfo || !data.userInfo.uploadFiles)return;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				_self.fn().clearMessage();
				if(error){
					_self.userMsg={show:true,type:'danger',list:[response?response:error]}
					return;
				}
				_self.createItemData.files=_self.createItemData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.createItemData.files=_self.createItemData.files.filter(d=>d.id!=file.id);
		},
		initJSTree(devOpsProjectData){
			let _self=this;
			if(_self.zendeskInfo && _self.zendeskInfo.userInfo && _self.zendeskInfo.userInfo.allowNodes){
			
				_self.fn().createJSTree('area_jstree',function(selectedObj){
					let selPath=selectedObj.path.replace('\\Area',''); //`${_self.createItemData.project.name}\\${selectedObj.text}`;
					selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
					selPath=_self.fn().handleTfsAreaIteration(selPath,'Area',_self.zendeskInfo.userInfo);
					_self.createItemData.fields['System.AreaPath']=selPath;

				});
				_self.fn().createJSTree('iterations_jstree',function(selectedObj){
					let selPath=selectedObj.path.replace('\\Iteration','');//`${_self.createItemData.project.name}\\${selectedObj.text}`;
					selPath=selPath.startsWith('\\')?selPath.substr(1,selPath.length-1):selPath;
					selPath=_self.fn().handleTfsAreaIteration(selPath,'Iteration',_self.zendeskInfo.userInfo);
					_self.createItemData.fields['System.IterationPath']=selPath;
				});

				_self.fn().updateJSTreeData('area_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='area'));
				_self.fn().updateJSTreeData('iterations_jstree', devOpsProjectData.nodesList.value.filter(d => d.structureType == 'iteration'));
				
				_self.handleDefAreaIteration(devOpsProjectData)
			}
		},
		handleDefAreaIteration(devOpsProjectData){
			const _self=this;

			let defArea='310';
			//filter default Zendesk area
			// let zdArea =devOpsProjectData.nodesList.value.find(d=>d.structureType=='area').children.find(d1=>d1.text=='Customer Support');
			// defArea=zdArea?zdArea.id.toString():'';

			setTimeout(function(){_self.fn().setJSTreeDefValue('area_jstree',defArea)},1000)
		},
		async initCreateItemData(data,projectId){
			let _self=this;
			let project;
			if(projectId){
				project=_self.devOpsProjects.find(d=>d.id==projectId);
			}

			let reproSteps = _self.createItemData.fields['Microsoft.VSTS.TCM.ReproSteps'];
			_self.createItemData.fields={
				'System.Title': data.ticket.subject,
			};
			if (reproSteps)_self.createItemData.fields['Microsoft.VSTS.TCM.ReproSteps'] = reproSteps;
			
			let comments=_self.zendeskInfo.ticket.comments;
			if(comments){
				let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
				_self.createItemData.fields['System.Description']=description_html;
			}
			_self.createItemData.hdTicketId=data.hdTicketId?data.hdTicketId:data.ticket.id;
			_self.createItemData.fields['System.TeamProject']=project?project.name:'';
			//_self.createItemData.fields['System.Title']=data.ticket.subject;
			//console.log('zendesk info',data);
			_self.createItemData.fields['Microsoft.VSTS.Common.Priority']=data.ticket.priority>0?data.ticket.priority:_self.handlePrioritySet(data.ticket.priority);
			_self.createItemData.fields['System.AssignedTo']='';
			_self.createItemData.fields['System.WorkItemType']='';
			_self.createItemData.fields['Microsoft.VSTS.Common.Severity']='';

			let defaultTags='swarm';
			if(_self.zendeskInfo.userInfo.allowTags
				&& _self.zendeskInfo.userInfo.allowHDTags){
				defaultTags=data.ticket.tags?data.ticket.tags:[];
				defaultTags=defaultTags.length>0?defaultTags.join(';'):'';
			}
			
			_self.createItemData.fields['System.Tags']=defaultTags;
			_self.createItemData.fields['System.TagsArr'] =_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];
			_self.showTags=true;

			//boolean
			await _self.mapFrontEndFields();

		},
		handlePrioritySet(priority){
			let intPriority='';
			switch(priority){
				case 'low':
					intPriority=4;
					break;
				case 'normal':
					intPriority=3;
					break;
				case 'high':
					intPriority=2;
					break;
				case 'urgent':
					intPriority=1;
					break;
			}
			return intPriority;
		},
		onDateChanged(date,el) {
			let _self = this;
			let referenceName=el.target.getAttribute('referenceName');
			_self.createItemData.fields[referenceName]=date?_self.apiDateValue(date):null;
		},
		htmlEditorChange(data){
			const _self=this;
			_self.createItemData.fields[data.referenceName]=data.htmlContent?data.htmlContent:null;
		},
		formatDateValue(date){
			if(!date) return null;
			return moment(date).format('MM/DD/YYYY');
		},
		apiDateValue(dateObj){
			let _self=this;
			let date=_self.formatDateValue(dateObj);
			//return date;
			if(!date) return null;
			
			var currentDate = new Date();
			var newDate= (new Date(`${date} `+currentDate.toLocaleTimeString()));
			newDate.setMinutes(newDate.getMinutes()+(currentDate.getTimezoneOffset()*-1));
			return newDate.toISOString();
			//return newDate;
		},
		async  mapFrontEndFields(){
			const _self=this;
			if(_self.zendeskInfo.userInfo.mapFields=='front-end'
			||_self.zendeskInfo.userInfo.mapFields=='both'){
				let fieldMapping=_self.fieldMapping;
				if(fieldMapping.filter(d=>d.type=='ticket').length>0 &&
					_self.ticket_fields.length<=0){
					_self.ticket_fields=[];
					let ticketMapping=fieldMapping.filter(d=>d.type=='ticket' && d.hdIsCustomField===1);
					for(var i=0;i<ticketMapping.length;i++){
						//await this.$store.dispatch('zendesk/getZdTicket_fields')//no need it
						let action=`ticket.customField:custom_field_${ticketMapping[i].hdFieldMappingId}`;
						let ticket_field=await parentClient.get(action);
						_self.ticket_fields=_self.ticket_fields.concat({
							id:ticketMapping[i].hdFieldMappingId,
							value:ticket_field[action]
						});
					}
					
				}

				for(var i=0;i<fieldMapping.length;i++){
					if(fieldMapping[i].type=='organization'){
						if(_self.zendeskInfo.ticket.organization.organizationFields &&
							_self.zendeskInfo.ticket.organization.organizationFields[fieldMapping[i].hdFieldMappingId]){
							let orgSelectedVal=_self.zendeskInfo.ticket.organization.organizationFields[fieldMapping[i].hdFieldMappingId];
							if(fieldMapping[i].options && orgSelectedVal){
								let fieldOrgOptObj=fieldMapping[i].options.find(d=>d.hdOptionValue==orgSelectedVal);
								if(fieldOrgOptObj){
									_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=fieldOrgOptObj.devOpsOptionValue?fieldOrgOptObj.devOpsOptionValue:'';
								}
							}
							else if(orgSelectedVal){
								_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=orgSelectedVal;
							}
						}
					}else if(fieldMapping[i].type=='ticket' && fieldMapping[i].hdIsCustomField===1){
						let ticket_fieldObj=	_self.ticket_fields.find(d=>d.id==fieldMapping[i].hdFieldMappingId);
						if(fieldMapping[i].options && ticket_fieldObj){
							let fieldOptObj=fieldMapping[i].options.find(d=>d.hdOptionValue==ticket_fieldObj.value);
							if(fieldOptObj){
								_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=fieldOptObj.devOpsOptionValue?fieldOptObj.devOpsOptionValue:'';
							}
						}
						else if(ticket_fieldObj){
							_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=ticket_fieldObj.value?ticket_fieldObj.value:'';
						}
					}else if(fieldMapping[i].type=='ticket' && fieldMapping[i].hdIsCustomField===0){
						let fieldVal=_self.zendeskInfo.ticket[fieldMapping[i].hdFieldType]?_self.zendeskInfo.ticket[fieldMapping[i].hdFieldType]:_self.zendeskInfo.ticket[fieldMapping[i].hdFieldMappingId]
						let fieldOpt=fieldMapping[i].options.find(d=>d.hdOptionValue==fieldVal);
						if(fieldOpt){
							_self.createItemData.fields[fieldMapping[i].devOpsFieldMappingId]=fieldOpt.devOpsOptionValue?fieldOpt.devOpsOptionValue:'';
						}
					}
				}
			}
		},
		workItemFields(){
			let _self=this;
			_self.devOpsProjectsFn(function(projectsResp){
				_self.fieldMapping=projectsResp.data.fieldMapping;
				let devOpsProjects=projectsResp.data.Data.value;
				_self.htmlMessage=projectsResp.data.htmlMessage;
				if(devOpsProjects && devOpsProjects.length>0){
					//_self.createItemData.projectId= devOpsProjects[0].id;
					_self.createItemData.projectId= devOpsProjects.find(d=>d.name=='SmartrWeb').id;
					_self.getDevOpsProjectData(function(devOpsProjectData){
						_self.devOpsProjects=devOpsProjects;
						_self.fn().showLoader(false);
						setTimeout(function(){_self.initDropzone(_self.zendeskInfo);},500);
						setTimeout(function(){
							_self.initJSTree(devOpsProjectData);
							// _self.fn().createHtmlEditor('editor_reproSteps','editor_reproSteps',null,function(editorObj,error){
							// 	_self.editor_reproSteps_Obj=editorObj?editorObj:null;
							// });
							let comments=_self.zendeskInfo.ticket.comments;
							if(comments){
								//let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
								//_self.createItemData.fields['System.Description']=description_html;
								// _self.fn().createHtmlEditor('editor_description','editor_description',description_html,function(editorObj,error){
								// 	_self.editor_description_Obj=editorObj?editorObj:null;
								// });
							}
						},1000);
					})
				}
				
			});
		},
		isResolutionOrAcptCriteriaFn(){
			const _self=this;
			let isFieldAvl=false;
			try{
				if(_self.devOpsProjectData.fieldsList &&
					_self.devOpsProjectData.fieldsList.value){
						let field=_self.devOpsProjectData.fieldsList.value.find(d=>d.referenceName=='Microsoft.VSTS.Common.AcceptanceCriteria'
						|| d.referenceName=='Microsoft.VSTS.Common.Resolution');
						
					isFieldAvl=(field && field!=null)?true:false;
				}
			}catch(ex){
				console.log('isResolutionOrAcptCriteria',ex);
			}
			_self.isResolutionOrAcptCriteria=isFieldAvl;
			return isFieldAvl;
		},
		isResolutionOrAcptCriteriaFn(){
			const _self = this;
			_self.isAcptCriteriaField=false;
			_self.isResolutionField = false;
			_self.isSystemInfoField=false;
			try{
				if(_self.devOpsProjectData.fieldsList && _self.devOpsProjectData.fieldsList.value){
						
					let field=_self.devOpsProjectData.fieldsList.value.find(d=>d.referenceName=='Microsoft.VSTS.Common.AcceptanceCriteria');
                    _self.isAcptCriteriaField=(field && field!=null)?true:false;

                    field=_self.devOpsProjectData.fieldsList.value.find(d=>d.referenceName=='Microsoft.VSTS.Common.Resolution');
					_self.isResolutionField = (field && field != null) ? true : false;
					
					field=_self.devOpsProjectData.fieldsList.value.find(d=>d.referenceName=='Microsoft.VSTS.TCM.SystemInfo');
                    _self.isSystemInfoField=(field && field!=null)?true:false;
				}
			}catch(ex){
				console.log('isResolutionOrAcptCriteria',ex);
			}
		},
		async getDevOpsProjectData(cb){
			let _self=this;
			let projectId=_self.createItemData.projectId;
			await _self.initCreateItemData(_self.zendeskInfo,projectId);
			_self.devOpsProjectDataFn(projectId,function(data){
				let devOpsProjectData=data.data.Data;
				//exclude System and Microsoft default fields from Custom Fields list
				// also exclude WEF_61C448B651F645D5883FCE6D92119478_Column
				//Custom fields to remove from UI
				let fieldsToRemove = ['Actual Time Spent', 'Automation', 'Automation Progess', 'Change Detail', 'Changed Since Last Update', 'Cost Centre', 'Customer', 'Deliverable', 'Demo Points', 'Environment',
					'Environment Solved', 'Estimate on Completion', 'Initial Estimate', 'Is Blocked', 'Priority New1', 'Review Status', 'SmartrSeverity', 'Sprint Goals', 'T Shirt Size', 'Tech Debt Type',
					'Tech Debt Value', 'Test Objective', 'Test Pre-Requisites', 'Third Party Action', 'Third Party Reference', 'Third Party Stakeholder', 'Type', 'Urgent', 'Zendesk Ticket Number', 'Zendesk Link',
					'Test Prerequisites','Support Priority','Milestone Type','Error Reference','Priority New','Notes'];
				devOpsProjectData.customFields=devOpsProjectData.fieldsList.value.filter(d=>d.referenceName 
					&& d.referenceName.indexOf('System.')<0 
					&& d.referenceName.indexOf('Microsoft.') < 0
					&& fieldsToRemove.indexOf(d.name)<0
					&& d.referenceName.indexOf('WEF_') != 0);
				
				_self.initFieldsDefaultVal(devOpsProjectData.fieldsList.value);
				_self.initPriortySeverity(devOpsProjectData.fieldsList.value);
				_self.devOpsProjectData=devOpsProjectData;
				_self.isResolutionOrAcptCriteriaFn();
				if(cb) cb(devOpsProjectData);
				else{
					_self.fn().showLoader(false);
					_self.fn().updateJSTreeData('area_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='area'));
					_self.fn().updateJSTreeData('iterations_jstree',devOpsProjectData.nodesList.value.filter(d=>d.structureType=='iteration'));
					//setTimeout(function(){_self.applyDatePicker();},1000);
				}
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the azure devops does not have required permissions.',
					'Can you please create azure devops token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000451379-how-to-create-azure-devops-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		initFieldsDefaultVal(fieldsList){
			const _self=this;
			let defaultValFields=fieldsList.filter(d=>d.defaultValue!==undefined || d.type=='boolean');
			if(defaultValFields){
				for(var i=0;i<defaultValFields.length;i++){
					if(defaultValFields[i].defaultValue){
						_self.createItemData.fields[defaultValFields[i].referenceName]=defaultValFields[i].defaultValue;
					}
					else if(defaultValFields[i].type=='boolean'){
						_self.createItemData.fields[defaultValFields[i].referenceName]=false;
					}
				}
			}

			let pickListFields=fieldsList.filter(d=>d.isPicklist || d.isIdentity);
			for(var i=0;i<pickListFields.length;i++){
				_self.createItemData.fields[pickListFields[i].referenceName]=_self.createItemData.fields[pickListFields[i].referenceName]?_self.createItemData.fields[pickListFields[i].referenceName]:'';
			}

		},
		initPriortySeverity(fieldsList) {
			const _self=this;
			let sv = fieldsList.find(d => d.referenceName == 'Microsoft.VSTS.Common.Severity');
			let svAllowedValues = ["1 - Critical", "2 - High", "3 - Medium", "4 - Low"];
			if (sv && sv.allowedValues) {
				svAllowedValues = sv.allowedValues;
			}
			_self.severityValues = svAllowedValues;

			let pr = fieldsList.find(d => d.referenceName == 'Microsoft.VSTS.Common.Priority');
			let prAllowedValues = [1,2,3,4];
			if (pr && pr.allowedValues) {
				prAllowedValues = pr.allowedValues;
			}
			_self.priorityValues = prAllowedValues;
		},
		async validateForm(){
			let isValid=await this.$validator.validateAll();
			
			if(!isValid){
				this.userMsg={show:true,type:'danger',list:[`Please scroll up and fill all required fields.`]}
			}
			return isValid;
		},
		//create init
		devOpsUsersFn:function(successCb,errorCb){
            var _self=this;
            var url = `dev-ops/users`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        devOpsProjectsFn:function(successCb,errorCb){
            var _self=this;
            var url = `dev-ops/projects`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        devOpsProjectDataFn:function(projectId,successCb,errorCb){
            var _self=this;
            var url = `dev-ops/projects/${projectId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		createWorkItemFn(){
			let _self=this;
			_self.fn().clearMessage();
			if(_self.editor_reproSteps_Obj)
				_self.createItemData.fields['Microsoft.VSTS.TCM.ReproSteps']=_self.fn().getHtmlEditorContent(_self.editor_reproSteps_Obj);

			if(_self.editor_description_Obj)
				_self.createItemData.fields['System.Description']=_self.fn().getHtmlEditorContent(_self.editor_description_Obj);
			
			_self.createItemData.fields['System.Tags']=_self.createItemData.fields['System.TagsArr']?_self.createItemData.fields['System.TagsArr'].join(';'):'';
			let data={..._self.createItemData};
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.project=_self.devOpsProjects.find(d=>d.id==data.projectId);

			let newFields={};
			for(var key in data.fields){
				if(data.fields[key]){
					newFields[key]=data.fields[key];
				}
			}
			data.fields=newFields;
			
			delete data.fields['System.TagsArr'];
			let url=`dev-ops/workitems/create`;
			_self.postServerFn(url,data,function(response){
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Work item created Successfully`]}
					_self.sendDataToParent(response.data);
				}else{
					_self.showTags=false;
					_self.createItemData.fields['System.TagsArr']=_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];
					setTimeout(function(){_self.showTags=true;},1000);
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Work item creation failed.`]}
				}
				_self.userMsg=userMsg;
			},function(error){ 
				_self.fn().showLoader(false);
				_self.showTags=false;
				_self.createItemData.fields['System.TagsArr']=_self.createItemData.fields['System.Tags']?_self.createItemData.fields['System.Tags'].split(';'):[];
				setTimeout(function(){_self.showTags=true;},1000);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		}
	},
	components:{HtmlEditor,TagsInput,[Select.name]: Select,[Option.name]: Option}
}

